import React, { useState } from 'react';
import './CountryPage.css';
import { Navbar } from './Navbar';
import { Overview } from './Overview';
import { Requirements } from './Requirements';
import { Intake } from './Intake';
import { Programs } from './Programs';
import { Cost } from './Cost';
import { TopCities } from './TopCities';
import { WorkOptions } from './WorkOptions';
import { Questions } from './Questions';
import { Link } from 'react-router-dom';

const CountryPage = ({country}) => {
  const [activeSection, setActiveSection] = useState('overview');

  return (
    <div className="country-page">
      <div className="country-hero">
        <div className="container">
          <h1>Study in { country.name }</h1>
          <div className="hero-content" style={{backgroundImage: `url(${country.image})`}}></div>
            <div className="hero-cta">
              <Link to="/apply">
                <button className="btn btn-primary">Apply Now</button>
              </Link>
            </div>
        </div>
      </div>

      <div className="country-content">
        <div className="container">
          <Navbar name={country.name} activeSection={activeSection} onSectionClick={setActiveSection} />
          {activeSection === 'overview' && <Overview country={country} />}
          {activeSection === 'requirements' && <Requirements country={country} />}
          {activeSection === 'intake' && <Intake country={country} />}
          {activeSection === 'programs' && <Programs country={country} />}
          {activeSection === 'cost' && <Cost country={country} />}
          {activeSection === 'topCities' && <TopCities country={country} />}
          {activeSection === 'workOptions' && <WorkOptions country={country} />}
          {activeSection === 'questions' && <Questions country={country} />}
        </div>
      </div>
    </div>
  );
};

export default CountryPage;
